import { render, staticRenderFns } from "./robotmigrate.vue?vue&type=template&id=48f9b0fe&scoped=true"
import script from "./robotmigrate.vue?vue&type=script&lang=js"
export * from "./robotmigrate.vue?vue&type=script&lang=js"
import style0 from "./robotmigrate.vue?vue&type=style&index=0&id=48f9b0fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f9b0fe",
  null
  
)

export default component.exports